import React, { Component } from 'react'
import {
  TableCell,
  TableRow,
  IconButton,
  TextField
} from '@material-ui/core'
import { DeleteRounded } from '@material-ui/icons'
import isEqual from 'react-fast-compare'

import { BUS_BRANDS } from "constants/arrays";

export class BusTableRow extends Component {
  state = {
    label: '',
    qty: '',
    brand: ''
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !isEqual(this.props, nextProps) || !isEqual(this.state, nextState)
  }

  onChange = e => this.setState({ [e.target.name]: e.target.value })

  onFocus = e => this.setState({ [e.target.name]: e.target.value })

  onBlur = id => e => {
    const { setBus } = this.props

    const value = e.target.value
    const name = e.target.name

    setBus({ id, value: value.trim(), field: name })
    this.setState({ [name]: '' })
  }

  onDelete = id => () => {
    const { deleteBus } = this.props

    deleteBus({ id })
  }

  render() {
    const { label, brand, qty } = this.state
    const { classes, id, company } = this.props

    const displayedLabel = label
      ? label
      : this.props.label
    const displayedQty = qty
      ? qty
      : this.props.qty
    const displayedBrand = brand
      ? brand
      : this.props.brand

    return (
      <TableRow>
        <TableCell padding='dense'>
          <TextField
            fullWidth
            select
            name='brand'
            value={displayedBrand}
            onBlur={this.onBlur(id)}
            onFocus={this.onFocus}
            onChange={this.onChange}
            SelectProps={{
              native: true
            }}
          >
            {BUS_BRANDS.map(brand => (
              <option key={brand} value={brand}>
                {brand}
              </option>
            ))}
          </TextField>
        </TableCell>

        <TableCell className={classes.tableCell} padding='none'>
          <TextField
            fullWidth
            name='label'
            value={displayedLabel}
            onBlur={this.onBlur(id)}
            onFocus={this.onFocus}
            onChange={this.onChange}
          />
        </TableCell>

        <TableCell className={classes.tableCell} padding='dense'>
          <TextField
            name='qty'
            type='number'
            value={displayedQty}
            onBlur={this.onBlur(id)}
            onFocus={this.onFocus}
            onChange={this.onChange}
          />
        </TableCell>

        <TableCell className={classes.tableCell} padding='none'>
          {company}
        </TableCell>

        <TableCell padding='checkbox'>
          <IconButton onClick={this.onDelete(id)}>
            <DeleteRounded fontSize='small' />
          </IconButton>
        </TableCell>
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Buses/components/BusTableRow/BusTableRow.js